import apiRequest from '@/http/api-request'
import {EventBus} from '@/utils/event-bus.js';
import router from '@/router'
import {getToken} from "@/utils/api";

export default {

  updatePassword({commit}, payload) {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams();
      params.append('password', payload.password);
      params.append('token', payload.token);

      apiRequest.doPostRequest('/client/password', params, {}, {skipJWT: true})
        .then(res => {
          commit('SET_TOKEN', res.token)
          EventBus.$emit('login')
          router.push(router.currentRoute.query.to || '/dashboard')

          resolve(res);
        })
        .catch(() => reject({message: 'A reset password link has expired'}));
    })
  },

  resetPassword(tmp, payload) {

    const params = new URLSearchParams();
    params.append('email', payload.email);

    return apiRequest.doPostRequest('/client/password/reset', params, {}, {skipJWT: true});
  },

  login({commit}, payload) {
    return new Promise((resolve, reject) => {

      const params = new URLSearchParams();
      params.append('email', payload.email);
      params.append('password', payload.password);

      apiRequest.doPostRequest('/login/admin', params, {}, {skipJWT: true}).then(res => {
        if (res.token) {

          commit('SET_TOKEN', res.token)
          EventBus.$emit('login')
          router.push(router.currentRoute.query.to || '/dashboard')

          resolve(res)
        } else {
          reject({message: 'Wrong Email or Password'})
        }
      })
        .catch(error => reject(error))
    })
  },

  registerUser({commit}, payload) {
    return new Promise((resolve, reject) => {

      const params = new URLSearchParams();
      params.append('first_name', payload.first_name);
      params.append('last_name', payload.last_name);
      params.append('password', payload.password);
      params.append('jwt', payload.jwt);

      apiRequest.doPostRequest('/client/register', params, {}, {skipJWT: true}).then(res => {
        if (res.token) {
          // Set accessToken
          commit('SET_TOKEN', res.token)

          router.push('/dashboard')
          resolve(res)
        } else {
          reject({message: 'Wrong Token'})
        }
      })
        .catch(error => reject(error))
    })
  },

  fetchProfileSettings({commit}, {charityId}) {
    return new Promise((resolve, reject) => {
      apiRequest.doGetRequest(`/charity/${charityId}/settings/profile`,
        {}, {'X-Harness-JWT': getToken()}, {skipCache: true})
        .then(adminInfo => {
          commit('SET_ADMIN_INFO', adminInfo);
          resolve(adminInfo);
        })
        .catch((error) => reject(error));
    });
  },
}
